import React from 'react';

import {untranslatable} from '../../../utilities/localize';

const TimelineBlock = ({translate, animation, icon, year, title, subtitle = null, text, odd = false, untranslatables}) => (
	<div className={["cd-timeline-block", animation].join(' ')}>
		<div className="cd-timeline-icon">
			<i className={`mdi mdi-${icon}`}/>
		</div>
		<div className="cd-timeline-content">
			{
				subtitle && (
					<p className="cd-year">
						{!odd && <span
							className="hide-on-small-only">{untranslatable(untranslatables, translate, 'subtitle', subtitle)}</span>}
						{year}
						{odd && <span
							className="hide-on-small-only">{untranslatable(untranslatables, translate, 'subtitle', subtitle)}</span>}
					</p>
				)
			}
			{
				subtitle && (
					<p className="cd-year">
						<span>{untranslatable(untranslatables, translate, 'subtitle', subtitle)}</span>
					</p>
				)
			}
			{
				!subtitle && (
					<span className="cd-year text">{year}</span>
				)
			}
			<h2>{translate(title)}</h2>
			<p>{translate(text)}</p>
		</div>
	</div>
);

export default TimelineBlock;



// WEBPACK FOOTER //
// ./src/components/elements/Resume/TimelineBlock.js